import { render, staticRenderFns } from "./app-remote-settings.vue?vue&type=template&id=086ed9e7"
import script from "./app-remote-settings.vue?vue&type=script&lang=js"
export * from "./app-remote-settings.vue?vue&type=script&lang=js"
import style0 from "./app-remote-settings.vue?vue&type=style&index=0&id=086ed9e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports